import $ from "jquery";

// Píxeles (en ancho de imagen config.w) agregados arriba de la imagen de cada
// piso después de trazar las rutas (config.mapTopOffset): todo lo que se
// dibuja sobre el plano se desplaza hacia abajo esa cantidad.
let mapTopOffset = 0;
export const setMapTopOffset = offset => {
  mapTopOffset = offset || 0;
};

export const distance = (a, b) => {
  a.x = parseInt(a.x, 10)
  a.y = parseInt(a.y, 10)
  b.x = parseInt(b.x, 10)
  b.y = parseInt(b.y, 10)
  return Math.sqrt((a.x - b.x) * (a.x - b.x) + (a.y - b.y) * (a.y - b.y));
};

export const getRoutePoints = (vertices, marginTop, config, floor, screenWidth) => {
  let waypoints = [];
  for (let i = 1; i < vertices.length; i++) {
    let pt0 = vertices[i - 1];
    let pt1 = vertices[i];
    // Usar las coordenadas originales y aplicar la misma transformación que los iconos
    let trans0 = transformWindowCoordinateToCanvasCoord(pt0.x, pt0.y, config.w, config.h, floor, screenWidth);
    let trans1 = transformWindowCoordinateToCanvasCoord(pt1.x, pt1.y, config.w, config.h, floor, screenWidth);
    let dx = trans1.x - trans0.x;
    let dy = trans1.y - trans0.y;
    let density = Math.sqrt(dx * dx + dy * dy) / 2;
    for (let j = 0; j < density; j++) {
      let x = trans0.x + dx * (j / density);
      let y = trans0.y + dy * (j / density);
      waypoints.push({ x: x, y: y });
    }
  }
  return waypoints;
};

export const transformWindowCoordinateToCanvasCoord = (x, y, w, h, floor, screenWidth) => {
  let deg = 16 * Math.PI / 180;
  let xRotated = x * Math.cos(deg) + y * Math.sin(deg);
  let yRotated = -x * Math.sin(deg) + y * Math.cos(deg);
  // Usar SIEMPRE el ancho explícito recibido (capturado una sola vez por MapView
  // en su estado) en vez de leer $(window).width() en vivo. La ruta y los iconos
  // se dibujan en llamadas separadas repartidas en varios segundos (animación por
  // etapas); si cada una relee el ancho de la ventana en ese momento, un simple
  // resize/orientation-change a mitad de la animación hace que unos puntos usen
  // una escala distinta a otros y el trazado quede desalineado. Con un valor
  // fijo pasado explícitamente, todo lo dibujado en una misma pasada usa
  // exactamente la misma escala.
  let width = screenWidth !== undefined ? screenWidth : $(window).width();
  let xPrima = width * xRotated /w;
  let height = width * h / w;
  let yPrima = height * yRotated  / h;
  yPrima += mapTopOffset * width / w;
  // Los offsets de calibración por piso se ajustaron a ojo en un canvas de
  // referencia de REFERENCE_WIDTH px de ancho. Son correcciones en PIXELES DE
  // PANTALLA, así que hay que escalarlos junto con el resto de la geometría
  // (que ya se escala por `width`); si se suman como constantes fijas, en un
  // canvas angosto (mobile) quedan enormes en proporción y el resultado se ve
  // muy desalineado o directamente fuera de los límites del canvas.
  const REFERENCE_WIDTH = 1905;
  let offsetScale = width / REFERENCE_WIDTH;
  if ([1, 2, 3].includes(parseInt(floor, 10))) {
    xPrima += 15 * offsetScale;
    yPrima -= 120 * offsetScale;
  } else if (parseInt(floor, 10) === -1) {
    xPrima += 227 * offsetScale;
    yPrima -= 120 * offsetScale;
  }
  return {
    x: xPrima,
    y: yPrima,
    margin: height * y  / h
  }
}


// WEBPACK FOOTER //
// ./src/utils/calc.js